import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { loginGoogle, register } from "store/actions/authAction";
import { useGoogleLogin } from "@react-oauth/google";
import { handleSwal } from "utils/sweetAlert";

import BrandIcon from "components/BrandIcon";
import Button from "elements/Button";
import LoadingButton from "elements/Button/loadingButton";
import { emailPattern, passwordPattern } from "utils/formPattertn";

import IcGoogle from "assets/images/ic_google.svg";

export default function RegisterForm({ handleMove }) {
  const { isLoading } = useSelector((state) => state.authReducer);
  const [data, setData] = useState({
    name: "",
    email: "",
    password: "",
    role: "",
  });

  const [passShow, setPassShow] = useState(false);
  const [emailValid, setEmailValid] = useState(null);
  const [passValid, setPassValid] = useState(null);

  const dispatch = useDispatch();
  const onChange = (event) => {
    const { name, value } = event.target;
    if (emailPattern.test(data.email)) {
      setEmailValid(true);
    } else {
      setEmailValid(false);
    }

    if (passwordPattern.test(data.password)) {
      setPassValid(true);
    } else {
      setPassValid(false);
    }

    setData({
      ...data,
      [name]: value,
    });
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    if (
      data.email !== "" &&
      data.password !== "" &&
      data.name !== "" &&
      data.role !== ""
    ) {
      dispatch(register(data));
    }
  };

  const googleLogin = useGoogleLogin({
    onSuccess: async (tokenResponse) => {
      dispatch(loginGoogle(tokenResponse.access_token));
    },
    onError: (error) => {
      handleSwal("Login Failed!", "error");
    },
  });

  return (
    <div className="content-wrapper fade">
      <BrandIcon />
      <h3>Register</h3>
      <form onSubmit={handleSubmit} className="mt-4 mb-2">
        {/* NAME */}
        <div className="form-group mb-3">
          <label htmlFor="name">Name</label>
          <div className="input-group">
            <input
              type="name"
              name="name"
              id="name"
              value={data.name}
              onChange={onChange}
              className="form-control"
              placeholder="Please type here..."
              aria-label="Name"
              required
            />
          </div>
        </div>

        {/* EMAIL */}
        <div className="form-group mb-3">
          <label htmlFor="email">Email</label>
          <div className="input-group">
            <input
              type="email"
              name="email"
              id="email"
              value={data.email}
              onChange={onChange}
              className={`form-control ${
                emailValid === false ? "is-invalid" : ""
              }`}
              placeholder="Please type here..."
              aria-label="Email"
              required
            />
          </div>
        </div>

        {/* PASSWORD */}
        <div className="form-group mb-3">
          <label htmlFor="password">Password</label>
          <div className="input-group">
            <input
              type={passShow ? "text" : "password"}
              name="password"
              id="password"
              value={data.password}
              onChange={onChange}
              className={`form-control ${
                passValid === false ? "is-invalid" : ""
              }`}
              placeholder="Please type here..."
              aria-label="Password"
              required
            />
            <span className="input-group-text" id="basic-addon1">
              <i
                onClick={() => setPassShow(!passShow)}
                className={`fas ${passShow ? "fa-eye" : "fa-eye-slash"}`}
              ></i>
            </span>
          </div>
          {!passValid && (
            <div className="validation mt-1">
              *password must be at least 8 character 1 uppercase and 1 number
            </div>
          )}
        </div>

        {/* ROLE */}
        <div className="form-group mb-3">
          <label htmlFor="role">Register as</label>
          <div className="input-text">
            <div className="input-group mb-1">
              <select
                className="form-select"
                aria-label="Default select example"
                name="role"
                value={data.role}
                onChange={onChange}
              >
                <option hidden>Open this select menu</option>
                <option value="BUYER">Buyer</option>
                <option value="SELLER">Seller</option>
              </select>
            </div>
          </div>
        </div>

        {isLoading ? (
          <LoadingButton />
        ) : (
          <Button className="btn btn-dark" isBlock>
            Register
          </Button>
        )}
        <p className="mt-2">
          Have an account? <span onClick={handleMove}>Sign In Here!</span>
        </p>
      </form>
      {isLoading ? (
        <LoadingButton />
      ) : (
        <Button
          type="button"
          onClick={googleLogin}
          className="btn btn-dark"
          isBlock
        >
          <img className="img-fluid" src={IcGoogle} alt="" /> Sign in with
          Google
        </Button>
      )}
    </div>
  );
}
